export const Name: unique symbol = Symbol('ObjectNameProp');
export const Owner: unique symbol = Symbol('FieldOwnerProp');
